import { BrowserModule } from '@angular/platform-browser';
import { NgModule, enableProdMode, ErrorHandler, Injectable, Injector, InjectionToken } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { Routes } from '@angular/router';
import { AppComponent } from './components/app/app.component';
import { HomeComponent } from './components/home/home.component';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRouter } from './app.router';

import { UiSwitchModule } from 'ngx-ui-switch';
import { ColorPickerModule } from 'ngx-color-picker';
/* --------- GLOBAL -------*/
import { ConfirmComponent } from './components/confirm/confirm.component';
import { AlertComponent } from './components/alert/alert.component';
import { SupportComponent } from './components/support/support.component';
import { ExportPdfComponent } from './components/export-pdf/export-pdf.component';
import { ExportCsvComponent } from './components/export-csv/export-csv.component';
import { GeneralService } from './components/class/general.service';
import { MoneyDirective } from './components/directives/number.directive';
import { PriceTextPipe } from './components/pipes/price-textpipe';

/* --------- TRACK ERROR -------*/


/* --------- RTB -------*/
import { RtbComponent } from './components/rtb/rtb/rtb.component';
import { InfoComponent } from './components/rtb/info/info.component';
import { LeftMenuComponent } from './components/rtb/left-menu/left-menu.component';
import { RightMenuComponent } from './components/rtb/right-menu/right-menu.component';
import { TableComponent } from './components/rtb/table/table.component';
import { UpMenuComponent } from './components/rtb/up-menu/up-menu.component';
import { GraphicDirective } from './components/rtb/directives/graphic.directive';
import { MenuItemDirective } from './components/rtb/directives/menu-item.directive';
import { DatepickerItemDirective } from './components/rtb/directives/datepicker-item.directive';
import { TableItemDirective } from './components/rtb/directives/table-item.directive';
import { EditModeItemDirective } from './components/rtb/directives/edit-mode-item.directive';
import { RtbRooftopItemDirective } from './components/rtb/directives/rtb-rooftop-item.directive';
import { ChannelItemDirective } from './components/rtb/directives/channel-item.directive';
import { SalesItemValueDirective } from './components/rtb/directives/sales-item-value.directive';
import { AddCampaignComponent } from './components/add-campaign/add-campaign.component';
import { ContextMenuComponent } from './components/rtb/context-menu/context-menu.component';
import { TextareaInfoExpenseDirective } from './components/rtb/directives/textarea-info-expense.directive';
import { RenameComponent } from './components/rename/rename.component';
import { MediaCalendarComponent } from './components/rtb/media-calendar/media-calendar.component';
import { SalesObjectivesComponent } from './components/rtb/sales-objectives/sales-objectives.component';

/* --------- Budget -------*/
import { BudgetComponent } from './components/budget/budget/budget.component';
import { TopPanelComponent } from './components/budget/top-panel/top-panel.component';
import { WrapperComponent } from './components/budget/wrapper/wrapper.component';
import { FooterComponent } from './components/budget/footer/footer.component';
import { LeftPanelComponent } from './components/budget/left-panel/left-panel.component';
import { RightPanelComponent } from './components/budget/right-panel/right-panel.component';
import { InfoBudgetComponent } from './components/budget/info-budget/info-budget.component';
import { ContextMenuBudget } from './components/budget/context-menu/context-menu.component';
import { ConfirmBudgetComponent } from './components/budget/confirm-budget/confirm-budget.component';
import { BudgetAddCampaignComponent } from './components/budget/add/add.component';

/* --------- Dealer Settings -------*/
import { DealerSettingsComponent } from './components/dealer/dealer-settings';
import { DealerAddAccessComponent } from './components/dealer/dealer-add-access.component';
import { DealerEditProductsComponent } from './components/dealer/dealer-edit-products.component';
import { DealerEditRootftopComponent } from './components/dealer/dealer-edit-rootftop.component';
import { DealerEventsComponent } from './components/dealer/dealer-events.component';
import { DealerLeftMenuComponent } from './components/dealer/dealer-left-menu.component';
import { DealerMenuMainComponent } from './components/dealer/dealer-menu-main.component';
import { DealerTreeComponent } from './components/dealer/dealer-tree.component';
import { DealerUploadComponent } from './components/dealer/dealer-upload.component';
import { DealerDashboardSettingsComponent } from './components/dealer/dealer-dashboard-settings.component';


/* --------- Dashboard -------*/
import { DashboardComponent } from './components/dashboard/dashboard/dashboard';
import { DashboardUpMenuComponent } from './components/dashboard/up-menu/dashboard-up-menu.component';


const appRoutes: Routes = <Routes>[
    { path: '', component: HomeComponent },
    { path: 'budget', component: BudgetComponent },
    { path: 'rtb', component: RtbComponent },
    { path: 'dealer', component: DealerSettingsComponent },
    { path: 'dashboard', component: DashboardComponent },
    { path: '**', redirectTo: '/', pathMatch: 'full' }
];
enableProdMode();
@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        BudgetComponent,
        RtbComponent,
        InfoComponent,
        LeftMenuComponent,
        RightMenuComponent,
        TableComponent,
        UpMenuComponent,
        GraphicDirective,
        MenuItemDirective,
        DatepickerItemDirective,
        TableItemDirective,
        DealerSettingsComponent,
        DealerAddAccessComponent,
        DealerEditProductsComponent,
        DealerEditRootftopComponent,
        DealerEventsComponent,
        DealerLeftMenuComponent,
        DealerMenuMainComponent,
        DealerTreeComponent,
        DealerUploadComponent,
        EditModeItemDirective,
        ConfirmComponent,
        DealerDashboardSettingsComponent,
        DashboardComponent,
        DashboardUpMenuComponent,
        RtbRooftopItemDirective,
        ChannelItemDirective,
        AddCampaignComponent,
        AlertComponent,
        ContextMenuComponent,
        TopPanelComponent,
        WrapperComponent,
        FooterComponent,
        LeftPanelComponent,
        RightPanelComponent,
        InfoBudgetComponent,
        ContextMenuBudget,
        TextareaInfoExpenseDirective,
        ConfirmBudgetComponent,
        AddCampaignComponent,
        TextareaInfoExpenseDirective,
        RenameComponent,
        MediaCalendarComponent,
        SalesObjectivesComponent,
        SalesItemValueDirective,
        SupportComponent,
        BudgetAddCampaignComponent,
        ExportPdfComponent,
        MoneyDirective,
        PriceTextPipe,
        ExportCsvComponent

    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        CommonModule,
        BrowserAnimationsModule,
        AppRouter,
        ColorPickerModule,
        UiSwitchModule
        //RouterModule.forRoot(appRoutes),
    ],
    providers: [GeneralService],
    bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts